import React, { Component } from 'react';
import { Form, Label, Input, Row, Col, Button } from 'reactstrap';
import Header from './HeaderComponent';

class Queue extends Component{
    constructor(props){
        super(props);
        this.state={
            queue: [],
            front: 0,
            rear: -1,
            lastDequeuedItem: null
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleQueue = this.handleQueue.bind(this);
        this.handleDequeue = this.handleDequeue.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    createArray(len, item){
        var arr1 = [item],
        arr2 = [];
        while (len > 0) {
            if (len & 1) arr2 = arr2.concat(arr1);
            arr1 = arr1.concat(arr1);
            len >>>= 1;
        }
        return arr2;
    }
    handleSubmit(event){
        if(this.size.value>0 && this.size.value<12){
            var temp = this.createArray(this.size.value, null);
            this.setState({
                queue: temp
            });
        }
        else{
            alert("Value should either be positive or less than 12");
        }
        event.preventDefault();
    }
    isQueueEmpty(length, rear, front){
        if(front-rear === 1 || front === length){
            return true;
        }
        return false;
    }
    isQueueFull(length, rear){
        if(rear === length-1){
            return true;
        }
        else{
            return false;
        }
    }
    handleQueue(event){
        var rear = this.state.rear;
        var queue = this.state.queue;
        if(!this.isQueueFull(queue.length, rear)){
            queue[++rear] = this.nextItem.value;
            this.setState({
                queue: queue,
                rear: rear
            });
        }
        else{
            alert("Queue is full, cannot insert");
        }
        event.preventDefault();
    }
    handleDequeue(){
        var front = this.state.front;
        var queue = this.state.queue;
        if(!this.isQueueEmpty(queue.length, this.state.rear, front)){
            var lastDequeuedItem = queue[front];
            queue[front++] = null;
            this.setState({
                front: front,
                queue: queue,
                lastDequeuedItem: lastDequeuedItem
            });
        }
        else{
            alert("Nothing to Dequeue");
        }
    }
    handleReset(){
        this.setState({
            queue: [],
            front: 0,
            rear: -1,
            lastDequeuedItem: null
        });
    }
    render(){
        var renderQueue = this.state.queue.map((item, index) => {
            return(
                <div key={index} className="col-1 queue-test bg-warning">
                    <div className="row align-items-center">
                        <div className="col-12 text-center">
                            <h4>{item}</h4>
                        </div>
                    </div>
                </div>
            );
        });
        if(this.state.queue.length !== 0){
            var temp = this.createArray(this.state.queue.length + 1, null);
            var renderIndex = temp.map((item, index)=>{
                return(
                    <div key={index} className="col-1 text-center">
                        <h5>{index-1}</h5>
                    </div>
                );
            });
            var renderFront = temp.map((item, index) => {
                return(
                    <div key={index} className="col-1 text-center">
                        {this.state.front === index - 1 ? <div>Front<br/><i className="fa fa-arrow-down"></i></div> : <div></div>}
                    </div>
                );
            });
            var renderRear = temp.map((item, index) => {
                return(
                    <div key={index} className="col-1 text-center">
                        {this.state.rear === index - 1 ? <div><i className="fa fa-arrow-up"></i><br/>Rear</div> : <div></div>}
                    </div>
                );
            });
        }
        else{
            renderIndex = () => {
                return(<div></div>);
            }
        }
        return(
            <>
                <Header destination="Linear Queue"/>
                <div className="container">
                    <div className="p-2 black-yellow mb-4">
                        <div className="row mt-2 mb-2">
                            <div className="col-12">
                                <h4>Introduction to Queue</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <p>A Queue is a linear structure which follows a particular order in which the operations are performed. The order is First In First Out (FIFO). A good example of a queue is any queue of consumers for a resource where the consumer that came first is served first. The difference between stacks and queues is in removing. In a stack we remove the item the most recently added; in a queue, we remove the item the least recently added.</p>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <h4>Operations on Queue</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                The two main operations on Queue are:-
                                <ul>
                                    <li><b>Enqueue:</b> Add an element to the end of the queue.</li>
                                    <li><b>Dequeue:</b> Remove an element from the front of the queue.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-12">
                            <h4>Visualization</h4>
                        </div>
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        <Row className="form-group">
                            <Col md={2}>
                                <Label htmlFor="size">Size</Label>
                            </Col>
                            <Col md={6}>
                                <Input required type="number" id="size" name="size" innerRef={(input) => this.size = input}/>
                            </Col>
                            <Col md={2}>
                                <Button color="primary" type="submit">Update</Button>
                            </Col>
                        </Row>
                    </Form>
                    <Form onSubmit={this.handleQueue}>
                        <Row className="form-group">
                            <Col md={2}>
                                <Label htmlFor="nextItem">Next Item</Label>
                            </Col>
                            <Col md={6}>
                                <Input required type="number" id="nextItem" name="nextItem" innerRef={(input) => this.nextItem = input}/>
                            </Col>
                            <Col md={2}>
                                <Button color="primary" type="submit">Queue</Button>
                            </Col>
                        </Row>
                    </Form>
                    <div className="row">
                        <div className="col-6">
                            <p>Size of Queue = {this.state.queue.length}</p>
                        </div>
                        <div className="col-3">
                            <Button onClick={this.handleDequeue} color="warning">Dequeue</Button>
                        </div>
                        <div className="col-3">
                            <Button onClick={this.handleReset} color="danger">Reset</Button>
                        </div>
                    </div>
                    <div className="row">
                        {renderFront}
                    </div>
                    <div className="row">
                        {renderIndex}
                    </div>
                    <div className="row">
                        <div className="col-1"></div>
                        {renderQueue}
                    </div>
                    <div className="row">
                        {renderIndex}
                    </div>
                    <div className="row">
                        {renderRear}
                    </div>
                </div>
            </>
        );
    }
}

export default Queue;